module.exports = __webpack_public_path__ + "img/new_business.30d795d8.svg";